import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_114_customers: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "123",
      action: "modulev1/customer_add",
    },
    title: "Customers",
    screenId: "114",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "customername",
            Name: "customer_summary",
             style: {
              maxHeight: "calc(100vh - 350px)", // Adjust height to fit view
            },
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/customer_add/<id>",
                },
                ActionType: "Edit",
                ScreenId: "123",
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "customer_summary",
                },
                ActionType: "Delete",
                ScreenId: "123",
              },
            ],
            Form: {
              Name: "customer_summary",
              TableName: "customer_details",
              View: "view_customer_summary",
              Filter:
                "view_customer_summary.soft_delete=0 order by view_customer_summary.created_at desc",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Ref.No",
                  BindValue: "code_number",
                  Json_Attribute: "code_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Name",
                  IsMandatory: true,
                  BindValue: "txt_customer_name",
                  Json_Attribute: "customername",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Lock",
                  BindValue: "lock_status",
                  Json_Attribute: "lock_status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Mobile",
                  IsMandatory: true,
                  BindValue: "txt_mobile",
                  Json_Attribute: "mobile",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Address",
                  IsMandatory: true,
                  BindValue: "txt_address",
                  Json_Attribute: "address",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Credit days",
                  IsMandatory: true,
                  BindValue: "txt_credit_days",
                  Json_Attribute: "creditdays",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Credit amount",
                  IsMandatory: true,
                  BindValue: "txt_credit_amount",
                  Json_Attribute: "creditamount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer type",
                  IsMandatory: true,
                  BindValue: "txt_customertype",
                  Json_Attribute: "customertype",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Due amount",
                  IsMandatory: true,
                  BindValue: "txt_due_amount",
                  Json_Attribute: "amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_created_by",
                  Json_Attribute: "created_by",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created at",
                  BindValue: "txt_created_at",
                  Json_Attribute: "created_at",
                  componentType: ComponentType.DATETIME_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "VAT certificate",
                  BindValue: "vat_certificate_attachment",
                  Json_Attribute: "vat_certificate_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Credit application form",
                  BindValue: "credit_application_form_attachment",
                  Json_Attribute: "credit_application_form_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Trade license",
                  BindValue: "trade_license_attachment",
                  Json_Attribute: "trade_license_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Others attachment",
                  BindValue: "others_attachment",
                  Json_Attribute: "others_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
